import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueGoogleMaps from "vue-googlemaps";
import VueMoment from "vue-moment";
// import "./registerServiceWorker";

import "@/assets/scss/_style.scss";
import "vue-googlemaps/dist/vue-googlemaps.css";

// import 'bootstrap/dist/js/bootstrap'
import "bootstrap";

// import plugins individually - require exports-loader
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tooltip";

//Plugins
import AuthPlugin from "./plugins/auth";
import ReportsPlugin from "./plugins/reports";
import UsersPlugin from "./plugins/users";

//Sentry
// import * as Sentry from "@sentry/browser";
// import * as Integrations from "@sentry/integrations";

// Sentry.init({
//   dsn: "https://ae037c6d437641198435a7525352b51f@sentry.io/1528072",
//   integrations: [new Integrations.Vue({ Vue, attachProps: true })]
// });

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Bugsnag.start({
  apiKey: "da0e5e212817ac4caaf3d8eb098e6141",
  plugins: [new BugsnagPluginVue()]
});

const bugsnagVue = Bugsnag.getPlugin("vue");
bugsnagVue.installVueErrorHandler(Vue);

// jquery
// eslint-disable-next-line
global.$ = $;

Vue.config.productionTip = false;

Vue.use(AuthPlugin);
Vue.use(ReportsPlugin);
Vue.use(UsersPlugin);

Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: "AIzaSyBM5PytiGG19RZS4kSQWBq_ieUS4AHUAb0",
    // Use new renderer
    useBetaRenderer: true
  }
});

Vue.use(VueMoment);

Vue.filter("utcToLocalCalendar", function(value) {
  if (!value) return "error";
  return Vue.moment.utc(value).local().calendar();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
